export enum USER_TYPES_INDEX {
  doctor = 1,
  patient = 2,
  secretary = 3,
  assistant = 4,
  admin = 5,
  superAdmin = 6,
  contact = 7
}
